import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import NightSky from './components/NightSky';
import DaySky from './components/DaySky';

// Pages
import Home from './pages/Home';
import Resume from './pages/Resume';
import Homelab from './pages/Homelab';
import Career from './pages/Career';
import InPractice from './pages/InPractice';
import Cultures from './pages/Cultures';
import NotFound from './pages/NotFound';

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem('tmc-theme') || 'light');

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('tmc-theme', theme);
  }, [theme]);

  return (
    <Router basename="/" future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="App">
        {/* One backdrop per theme, rendered rather than hidden, so the other
            costs nothing. */}
        {theme === 'dark' ? <NightSky /> : <DaySky />}
        <Navbar theme={theme} onThemeChange={() => setTheme(theme === 'light' ? 'dark' : 'light')} />
        <main className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/career" element={<Career />} />
            <Route path="/in-practice" element={<InPractice />} />
            <Route path="/cultures" element={<Cultures />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/homelab" element={<Homelab />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;